// ─── CONFIG ──────────────────────────────────────────────────────────────────
export const VAT_RATE     = 0.14;
// Keys are read from environment variables (REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY).
// Fallback values keep the app working until those vars are configured in Vercel.
// Fallbacks point at the CURRENT project (Sedra B2B, eu-central-1). The old
// project radcfbsezwxujmngxlpp was abandoned on 22 Aug 2026 after its org hit
// the Free Plan egress cap; leaving it here as a fallback meant a missing env
// var would silently route production at a dead backend returning 402.
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://dvssssazmtzbfhncygkt.supabase.co';
export const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_L6tqUJ3yMQWtCJomA7YvNA_rDxrc38_';
export const SESSION_KEY  = 'sdra_auth_v2';

// The brand mark used in headers, sidebars and auth screens. It used to be
// fetched from Supabase Storage on every screen of every visit; serving it from
// public/ means Vercel's CDN handles it for free and it costs zero Supabase
// egress. It is also the only logo that still renders while Storage is down.
// The real brand mark, recovered from the old project's Storage and resized
// from 1260px to 512px (24 KB). Served from public/ so Vercel's CDN handles it
// for free — it used to be fetched from Supabase Storage on every screen of
// every visit, which is exactly the pattern that exhausted the egress quota.
export const LOGO_URL     = '/logo.jpg';
export const STAFF_FN     = `${SUPABASE_URL}/functions/v1/manage-staff`;
export const VENDOR_FN    = `${SUPABASE_URL}/functions/v1/manage-vendor`;

// ─── ROLE PERMISSION MATRICES ─────────────────────────────────────────────────
// Which tabs each role can navigate to
export const ROLE_TABS = {
  super_admin: ['dashboard', 'products', 'customers', 'orders', 'applications', 'vendors', 'banners', 'analytics', 'settings', 'staff'],
  manager:     ['dashboard', 'products', 'customers', 'orders', 'applications', 'vendors', 'banners'],
  sales:       ['orders'],
  warehouse:   ['orders'],
};

// Can edit products / customers (add / edit / delete)
export const CAN_EDIT = {
  super_admin: true,
  manager:     true,
  sales:       false,
  warehouse:   false,
};

// Can advance order status
export const CAN_STATUS = {
  super_admin: true,
  manager:     true,
  sales:       false,
  warehouse:   true,
};

// Can see order totals, revenue, subtotals, invoices, and CSV export — super_admin ONLY
export const CAN_SEE_TOTALS = {
  super_admin: true,
  manager:     false,
  sales:       false,
  warehouse:   false,
};

export const ROLE_BADGE = {
  super_admin: { label: 'Super Admin', color: '#7C3AED', bg: '#EDE9FE' }, // no brand/status token for this accent — kept literal
  manager:     { label: 'Manager',     color: 'var(--status-info)',    bg: 'var(--status-info-bg)' },
  sales:       { label: 'Sales',       color: 'var(--status-warn)',    bg: 'var(--status-warn-bg)' },
  warehouse:   { label: 'Warehouse',   color: 'var(--status-success)', bg: 'var(--status-success-bg)' },
  vendor:      { label: 'Vendor',      color: 'var(--sedra-sage-ink)', bg: 'var(--sedra-sage-wash)' },
};
